import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ToastContext = createContext(null);

let toastIdCounter = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const addToast = useCallback((type, message, opts = {}) => {
    // Boş/falsy mesaj sessizce başarısız olmasın — fallback mesaj kullan
    const safeMessage = message || (type === 'error' ? 'Bir hata oluştu' : 'İşlem tamamlandı');
    const id = ++toastIdCounter;
    const duration = opts.duration != null ? opts.duration : (type === 'error' ? 5000 : 3000);
    setToasts(prev => [...prev, { id, type, message: safeMessage, title: opts.title }]);
    if (duration > 0) {
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, duration);
    }
    return id;
  }, []);

  const toast = useMemo(() => ({
    success: (msg, opts) => addToast('success', msg, opts),
    error: (msg, opts) => addToast('error', msg, opts),
    warning: (msg, opts) => addToast('warning', msg, opts),
    info: (msg, opts) => addToast('info', msg, opts),
  }), [addToast]);

  return (
    <ToastContext.Provider value={{ toast, toasts, dismiss }}>
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider');
  return ctx.toast;
}

export function useToastState() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToastState must be used inside ToastProvider');
  return { toasts: ctx.toasts, dismiss: ctx.dismiss };
}
